
const styles = ({ spacing, palette, mixins }) => ({
    root: {
        backgroundColor: palette?.background?.page,
        width: '100%',
        minHeight: 'calc(90vh - 88px)',
        // flexGrow: 1,
        padding: spacing(),
        marginRight: spacing(2),
        borderRadius: mixins.borderRadius,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        position: 'relative',
        overflow: 'hidden',
    },
    cleanRow: {
         "& .MuiTableRow-root": {
            '&:nth-of-type(odd)': {
                backgroundColor: "transparent",
            },
        },
    },
    info: {
        display: 'flex',
        justifyContent: "top",
        flexDirection: "column",
        width: '100%',
        valign: "top",
        alignItems: "top",
        marginTop: spacing(1),
    },
    icon: {
        width: '1.5rem',
        height: '1.5rem',
    },
    table: {
        borderRadius: mixins?.borderRadius,
        border: '10px blue',
        padding: '10px',
        backgroundColor: palette?.background?.page,
        width: '100%',
        height: "100%",
        valign: "top",
        alignItems: "top",
    },
    jsonPaper: {
        margin: 5,
        padding: 10,
        width: 700,
        borderRadius: 6
    },
    heading: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: '0.5rem'
    },
    left: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: '1rem'
    },
    right: {
        alignItems: "center",
        display: "flex"
    },

})

export default styles
